import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuth: false,
    loggedUser: {},
    users: [],
    loadingUsers: false,
    papeis: [],
    departamentos: [],
    todosOsDepartamentos: [],
    loadingDepartments: false,
    empresas: [],
    loadingCompanies: false,
    contasGerenciais: [],
    listaDeBancos: [],
    pais: [],
    todasAsContasGerenciais: [],
    loadingManagementAccounts: false,
    fornecedores: [],
    fornecedoresDoTipo: [],
    loadingProviders: false,
    myRequests: [],
    loadingRequests: false,
    loadingViewRequest: false,
    totalDespesas: 0,
    pagamentos: [],
    cacheCG: {
      idContasGerenciais: [],
      idCentrosDeCustos: [],
      centroDeCustos: [],
      contasGerenciais: [],
    },
    centroDeCustos: [],
    listaDeStatus: [
      {
        nome: "Todos",
        valor: "",
      },
      {
        nome: "Enviado ao gestor",
        valor: "ENVIADO_PARA_GESTOR",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Reprovado pelo gestor",
        valor: "REPROVADO_PELO_GESTOR",
        classe: "red--text text-xs-center",
      },
      {
        nome: "Enviado para o Contas a Pagar",
        valor: "ENVIADO_PARA_FINANCEIRO",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Reprovado pelo Contas a Pagar",
        valor: "REPROVADO_PELO_FINANCEIRO",
        classe: "red--text text-xs-center",
      },
      {
        nome: "Enviado ao Administrador financeiro",
        valor: "ENVIADO_PARA_ADM_FINANCEIRO",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Reprovado pelo administrador financeiro",
        valor: "REPROVADO_PELO_ADM_FINANCEIRO",
        classe: "red--text text-xs-center",
      },
      {
        nome: "Enviado a contabilidade",
        valor: "ENVIADO_PARA_CONTABILIDADE",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Pagamento devolvido",
        valor: "REPROVADO_PELO_PROCURADOR",
        classe: "red--text text-xs-center",
      },
      {
        nome: "Reprovado pela contabilidade",
        valor: "REPROVADO_PELA_CONTABILIDADE",
        classe: "red--text text-xs-center",
      },
      {
        nome: "Pagamento Autorizado",
        valor: "ENVIADO_PARA_PROCURADOR",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Enviado para Adm fornecedor",
        valor: "ENVIADO_PARA_ADM_FORNECEDOR",
        classe: "blue--text text-xs-center",
      },
      {
        nome: "Pago",
        valor: "APROVADO_PELO_PROCURADOR",
        classe: "green--text text-xs-center",
      },
    ],
    snackbar: {
      ativo: false,
      mode: "multi-line",
      y: "top",
      timeout: 30000,
      texto: "Olaaaa",
      ativarFechado: true,
      tipo: "success",
    },
  },
  getters,
  mutations,
  actions,
});
